var Effect = /* @__PURE__ */ ((Effect2) => {
  Effect2["ROBOT"] = "robot";
  Effect2["LOLITA"] = "lolita";
  Effect2["LOWPASS"] = "lowpass";
  Effect2["ECHO"] = "echo";
  Effect2["EQ"] = "eq";
  Effect2["LPFILTER"] = "lpfilter";
  Effect2["HPFILTER"] = "hpfilter";
  return Effect2;
})(Effect || {});
((Effect2) => {
  function fromString(effect) {
    switch (effect) {
      case "robot":
        return "robot" /* ROBOT */;
      case "lolita":
        return "lolita" /* LOLITA */;
      case "lowpass":
        return "lowpass" /* LOWPASS */;
      case "echo":
        return "echo" /* ECHO */;
      case "eq":
        return "eq" /* EQ */;
      case "lpfilter":
        return "lpfilter" /* LPFILTER */;
      case "hpfilter":
        return "hpfilter" /* HPFILTER */;
      default:
        return void 0;
    }
  }
  Effect2.fromString = fromString;
})(Effect || (Effect = {}));

export { Effect };
//# sourceMappingURL=effect.enum.js.map
